import { FC } from 'react';

export interface IQuestionIconProps {
  className?: string;
  height?: number;
  width?: number;
}

export const QuestionIcon: FC<IQuestionIconProps> = ({ className, height, width }) => {
  const customClass = className ? ` ${className}` : '';
  const iconHeight = height ?? 16;
  const iconWidth = width ?? 16;
  return (
    <svg
      data-testid="question-icon"
      className={`question-icon${customClass}`}
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8 12.6094C8.43147 12.6094 8.78125 12.2596 8.78125 11.8281C8.78125 11.3967 8.43147 11.0469 8 11.0469C7.56853 11.0469 7.21875 11.3967 7.21875 11.8281C7.21875 12.2596 7.56853 12.6094 8 12.6094Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.57803 3.57863 0 8 0C12.422 0 16 3.57863 16 8C16 12.422 12.4214 16 8 16C3.57803 16 0 12.4214 0 8ZM1.25 7.99998C1.25 11.731 4.26947 14.75 8 14.75C11.731 14.75 14.75 11.7305 14.75 7.99998C14.75 4.26895 11.7305 1.24999 8 1.24999C4.26897 1.24999 1.25 4.26945 1.25 7.99998Z"
      />
      <path d="M8.00001 4.01562C6.6215 4.01562 5.5 5.13712 5.5 6.51562C5.5 6.86081 5.77981 7.14062 6.125 7.14062C6.47019 7.14062 6.75 6.86081 6.75 6.51562C6.75 5.82637 7.31076 5.26562 8.00001 5.26562C8.68926 5.26562 9.25001 5.82637 9.25001 6.51562C9.25001 7.20487 8.68926 7.76562 8.00001 7.76562C7.65482 7.76562 7.37501 8.04544 7.37501 8.39062V9.95312C7.37501 10.2983 7.65482 10.5781 8.00001 10.5781C8.3452 10.5781 8.62501 10.2983 8.62501 9.95312V8.93653C9.70208 8.65831 10.5 7.6784 10.5 6.51562C10.5 5.13712 9.37851 4.01562 8.00001 4.01562Z" />
    </svg>
  );
};

export default QuestionIcon;
